import React from 'react';
import {URIMG } from "../../Conexiones/Conexion";
import { Link, useNavigate } from "react-router-dom";

function CardProyecto({ titulo, imagen, direccion, id }) {
    const navigate = useNavigate();
    const select = (id) => {
        sessionStorage.setItem("proyecto", id);
        navigate("Lista-Obras");
    };

    return (
        <div>
            <div className="card2" style={{marginTop:"10px"}}>
                <img className="card__image"  type="button" id={id} onClick={() => select(id)} 
                    src={URIMG + imagen} as={Link} to={direccion} alt=""/>
                <div className="card__overlay" style={{backgroundColor:"#82D6FF"}}>
                    <div className="card__header" style={{backgroundColor:"#82D6FF"}}>
                        <svg className="card__arc" xmlns="http://www.w3.org/2000/svg">{/*<path style={{fill:"#82D6FF"}}/>*/}</svg>                     
                        <div className="card__header-text" style={{marginBottom:"30px"}}>
                            <h3 className="card__title" >{titulo}</h3>            
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default CardProyecto;